let Widgets = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.digitalTile();
    },

    digitalTile () {
        let _this = this;

        const form = $('#digitalTileWidgetForm');

        if (form.length) {
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                    } else {
                        toastr.error(response.message);
                    }
                    submitBtn.stop();
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        $(document).on('ifUnchecked', '#digitalTileWidgetEnabled', function () {
            $('#digitalTileOptionsList').hide();
        });
        $(document).on('ifChecked', '#digitalTileWidgetEnabled', function () {
            $('#digitalTileOptionsList').show();
        });
    },
};

$().ready(function () {
    window.Widgets = Widgets;
    window.Widgets.init();
});
